/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";
import { Toaster } from "react-hot-toast";

import Header from "src/components/layouts/Header.react";
import Footer from "src/components/layouts/Footer.react";

/**
 * The Layout component
 *
 * @author Thais Watanabe
 */
const Layout = (props) => {
  return (
    <>
      <div>
        <Toaster
          position="top-right"
          reverseOrder={false}
          toastOptions={{
            // Define default options
            duration: 5000,
          }}
        />
      </div>

      <div className="min-h-screen bg-gray-100 font-NotoSansJP">
        <Header {...props} />

        <main className="-mt-32">
          <div className="max-w-7xl mx-auto pb-12 px-4 sm:px-6 lg:px-8">
            {props.children}
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default Layout;
